export const BRAND_TARGET_SIZE_INCHES = 1;
export const SMALL_BRAND_TARGET_SIZE_INCHES = 0.5;
export const LARGE_BRAND_TARGET_SIZE_INCHES = 2;

export const BrandCategory = Object.freeze({
  SHAPES_SYMBOLS: 'shapes_symbols',
  ALPHANUMERIC_LARGE: 'alphanumeric_large',
  ALPHANUMERIC_SMALL: 'alphanumeric_small',
  GREEK_ALPHABET: 'greek_alphabet',
});

export const BRANDS_SHAPES_SYMBOLS = [
    'circle-outline',
    'heart-outline',
    'diamond-outline',
    'circle-silhouette',
    'heart-silhouette',
    'diamond-silhouette',
    'clubs',
    'spade',
    'bar',
    'quarter-circle',
    'wavy-line',
    'mill-iron',
    'rising-sun',
    'arrow',
    'rafter',
    'musical-note',
    'hashtag',
    'at-symbol',
    'dollar-sign',
    'ampersand',
    'checkmark',
    'peace-sign',
    'infinity',
    'simple-cross',
    'cross',
    'boat-anchor',
    'fleur-de-lis',
    'wolf',
    'horse',
    'bison',
    'wing-left',
    'wing-right',
    'antler-left',
    'antler-right',
    'flying-bird',
    'hatchet',
    'longhorn',
    'longhorn-skull',
    'horse-head',
    'bucking-bronco',
    'cowboy-boot',
    'cowboy-hat',
    'snake',
    'cactus',
    'guitar',
    'cancer-ribbon',
    'crown',
    'airplane',
    'arrowhead',
    'golf-flag',
    'crossed-guns',
    'pistol',
    'horseshoe',
    'duck',
    'fish',
    'sea-turtle',
    'wave',
    'dog-bone',
    'dog-paw',
    'elephant',
    'sasquatch',
    'chicken',
    'clover',
    'magnolia-flower',
    'flower',
    'sunflower',
    'palm-tree',
    'pine-tree',
    'medium-star',
    'small-star',
    'star-outline',
    'crescent-moon',
    'lightning-bolt',
    'sun',
    'mountains',
    'heifer',
    'sheep',
    'pig',
    'goat',
    'everwest-small',
    'everwest-large'
];

export const BRANDS_ALPHANUMERIC = [
    'letter-a',
    'letter-b',
    'letter-c',
    'letter-d',
    'letter-e',
    'letter-f',
    'letter-g',
    'letter-h',
    'letter-i',
    'letter-j',
    'letter-k',
    'letter-l',
    'letter-m',
    'letter-n',
    'letter-o',
    'letter-p',
    'letter-q',
    'letter-r',
    'letter-s',
    'letter-t',
    'letter-u',
    'letter-v',
    'letter-w',
    'letter-x',
    'letter-y',
    'letter-z',
    'number-0',
    'number-1',
    'number-2',
    'number-3',
    'number-4',
    'number-5',
    'number-6',
    'number-7',
    'number-8',
    'number-9'
    ];

export const BRANDS_GREEK_ALPHABET = [
    'alpha',
    'beta',
    'gamma',
    'delta',
    'epsilon',
    'zeta',
    'eta',
    'theta',
    'iota',
    'kappa',
    'lambda',
    'mu',
    'nu',
    'omicron',
    'pi',
    'rho',
    'sigma',
    'tau',
    'upsilon',
    'phi',
    'chi',
    'psi',
    'omega',
];
